<template>
  <a-card :bordered="false">
    <div>
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="购销全流程">
                <a-select
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="null"
                  show-search
                  allow-clear
                  v-model="queryParam.project_id"
                  placeholder="请输入名称"
                  :default-active-first-option="false"
                  @search="this.projectSearch"
                  @change="handleProjectChange"
                >
                  <a-select-option v-for="d in projectList" :key="d.id">
                    {{ d.name }}（{{ d.number }}）
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="24">
              <a-form-item label="系统编号">
                <a-input v-model="queryParam.sell_contract_number" placeholder="系统编号" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="24">
              <a-form-item label="合同号">
                <a-input v-model="queryParam.sell_contract_contract_number" placeholder="合同号" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="2" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              </span>
            </a-col>
            <a-col :md="2" :sm="24" v-if="false">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleArchived">批量存档</a-button>
              </span>
            </a-col>
            <a-col :md="4" :sm="24" v-if="true">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleAdd">新建</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <s-table
        ref="table"
        size="small"
        rowKey="id"
        :loading="loading"
        :columns="columns"
        :data="loadData"
        :scroll="{ x: 1500 }"
      >
        <span slot="serial" slot-scope="text, record, index">
          {{ index + 1 }}
        </span>
        <span slot="approval_needed" slot-scope="text, item">
          <a-popconfirm
            title="确定开启审批吗?"
            :disabled="text"
            @confirm="() => approvalNeeded(item, undefined, false)">
            <a-switch checked-children="是" un-checked-children="否" :checked="item.is_approval_needed" :disabled="item.is_approval_needed"/>
          </a-popconfirm>
        </span>
        <span slot="archived" slot-scope="text, item">
          <a-popconfirm
            title="确定存档吗?"
            :disabled="text"
            @confirm="() => archived(item)">
            <a-switch checked-children="是" un-checked-children="否" :checked="item.is_archived" :disabled="item.is_archived"/>
          </a-popconfirm>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a @click="handleClient(record)">附件</a>
            <a-divider type="vertical" v-if="isEdited(record.create_by_id)"/>
            <a @click="handleEdit(record)" v-if="isEdited(record.create_by_id)">编辑</a>
            <a-divider type="vertical" v-if="isEdited(record.create_by_id)"/>
            <a-popconfirm
              v-if="isEdited(record.create_by_id)"
              title="确定要删除么？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="handleDelete(record)"
            >
              <a>删除</a>
            </a-popconfirm>
            <a-divider type="vertical" v-if="record.is_approval_needed && record.status === 3 && isEdited(record.create_by_id)"/>
            <a-popconfirm
              v-if="record.is_approval_needed && record.status === 3 && isEdited(record.create_by_id)"
              title="确定重启审批?"
              @confirm="() => approvalNeeded(record, 'customs_declaration_in', true)">
              <span>重启审批</span>
            </a-popconfirm>
          </template>
        </span>
      </s-table>
      <create-form
        ref="createModal"
        :visible="visible"
        v-if="visible"
        :loading="confirmLoading"
        :model="mdl"
        @cancel="handleAddCancel"
        @ok="handleOk"
      />
    </div>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import CreateForm from '../modules/CreateOutForm'
import debounce from 'lodash/debounce'
import { client_list } from '@/api/trade_client'
import {
  customs_declaration_out_create,
  customs_declaration_out_list,
  customs_declaration_out_delete,
  customs_declaration_out_archived,
  customs_declaration_out_update
} from '@/api/trade_customs_declaration'
import { project_list } from '@/api/trade_project'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm
  },
  data () {
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    this.clientSearch = debounce(this.handleClientSearch, 800)
    return {
      clientList: [],
      projectList: [],
      loading: false,
      approval_again: false,
      confirmLoading: false,
      // 创建窗口控制
      visible: false,
      archived_visible: false,
      mdl: {},
      // 查询参数
      queryParam: {
        client_ids: []
      },
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '合同协议号',
          dataIndex: 'contract_protocol_number',
          width: 120,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '购销全流程',
          dataIndex: 'project',
          width: 150,
          ellipsis: true
        },
        {
          title: '销售合同编号',
          dataIndex: 'sell_contract_number',
          width: 150,
          ellipsis: true
        },
        {
          title: '境内发货人',
          dataIndex: 'shipper',
          width: 120,
          ellipsis: true
        },
        {
          title: '境外收货人',
          dataIndex: 'recipient',
          width: 120,
          ellipsis: true
        },
        {
          title: '生产销售单位',
          dataIndex: 'product_sales_location',
          width: 120,
          ellipsis: true
        },
        {
          title: '进口申报日期',
          dataIndex: 'declaration_date',
          width: 120,
          ellipsis: true
        },
        {
          title: '离境口岸',
          dataIndex: 'departure_port',
          width: 120,
          ellipsis: true
        },
        {
          title: '监管方式',
          dataIndex: 'supervision_mode',
          width: 120,
          ellipsis: true
        },
        {
          title: '贸易国（地区）',
          dataIndex: 'trading_nations',
          width: 120,
          ellipsis: true
        },
        {
          title: '运抵国（地区）',
          dataIndex: 'arrival_country',
          width: 120,
          ellipsis: true
        },
        {
          title: '货物名称',
          dataIndex: 'product_name',
          width: 120,
          ellipsis: true
        },
        {
          title: '商品编码',
          dataIndex: 'product_code',
          width: 120,
          ellipsis: true
        },
        {
          title: '毛重',
          dataIndex: 'gross_weight',
          width: 120,
          ellipsis: true
        },
        {
          title: '件数',
          dataIndex: 'quantity',
          width: 120,
          ellipsis: true
        },
        {
          title: '数量',
          dataIndex: 'count',
          width: 120,
          ellipsis: true
        },
        {
          title: '单价',
          dataIndex: 'unit_price',
          width: 120,
          ellipsis: true
        },
        {
          title: '总价',
          dataIndex: 'total_price',
          width: 120,
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'unit',
          width: 120,
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.unit[text] || '无'
        },
        {
          title: '原产国',
          dataIndex: 'country_of_origin',
          ellipsis: true,
          width: 120
        },
        {
          title: '报关单号',
          dataIndex: 'customs_declaration_number',
          ellipsis: true,
          width: 120
        },
        {
          title: '征免',
          dataIndex: 'levy_exemption_type',
          ellipsis: true,
          width: 120
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          width: 120
        },
        {
          title: '开启审批',
          dataIndex: 'is_approval_needed',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'approval_needed' }
        },
        {
          title: '已存档',
          dataIndex: 'is_archived',
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'archived' }
        },
        {
          title: '审批状态',
          dataIndex: 'status',
          align: 'center',
          width: 100,
          customRender: (text, record) => record.is_approval_needed ? this.$Dictionaries.approval_result[text] : '未开启审批'
        },
        {
          title: '创建人',
          dataIndex: 'create_by',
          width: 150,
          ellipsis: true
        },
        {
          title: '时间',
          dataIndex: 'create_time',
          width: 180,
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '210px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return customs_declaration_out_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          getCheckboxProps: record => ({
            props: {
              disabled: record.is_archived
            }
          }),
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
    if (this.$route.query && this.$route.query.id) {
      this.queryParam['id'] = this.$route.query.id
    }
  },
  computed: {
    isEdited () {
      return (create_by_id) => {
        const info = this.$store.state.user.info
        return create_by_id === info.id || create_by_id === -1
      }
    }
  },
  methods: {
    handleProjectSearch (value) {
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = result
      })
    },
    handleProjectChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleProjectSearch(value)
      }
    },
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            getCheckboxProps: record => ({
              props: {
                disabled: record.is_archived
              }
            }),
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      const date = new Date()
      this.mdl = { number: date.getFullYear() + '' + (date.getMonth() + 1) + date.getDate() }
      this.visible = true
    },
    handleArchived () {
      if (this.selectedRowKeys.length > 0) {
        this.archived_visible = true
      } else {
        this.$message.info('选择存档记录')
      }
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleArchivedCancel () {
      this.archived_visible = false
      const form = this.$refs.archivedModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleEdit (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/customs_declaration_out/' + record.id })
    },
    handleClient (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/customs_declaration_out/' + record.id + '/attachment', query: { record: record.name } })
    },
    approvalNeeded (record, type, approval_again) {
      const is_approval_needed = approval_again ? true : !record.is_approval_needed
      if (is_approval_needed) {
        this.loading = true
        customs_declaration_out_update({ is_approval_needed: true }, record.id).then(res => {
          if (res.code === 1000) {
            this.$refs.table.refresh()
          }
        }).finally(() => {
          this.loading = false
        })
      } else {
        customs_declaration_out_update({ is_approval_needed: !record.is_approval_needed }, record.id).then(res => {
          if (res.code === 1000) {
            this.$refs.table.refresh()
          }
        })
      }
    },
    archived (record) {
      customs_declaration_out_update({ is_archived: !record.is_archived }, record.id).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleDelete (record) {
      customs_declaration_out_delete(record.id).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleOk (date) {
      const form = this.$refs.createModal.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
            // 新增
          values['attachment'] = date['attachment']
          this.confirmLoading = true
          customs_declaration_out_create(values).then(res => {
              // 刷新表格
              if (res.code === 1000) {
                this.$refs.table.refresh()
                this.visible = false
                this.confirmLoading = false
                // 重置表单数据
                form.resetFields()
              }
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleArchivedOK () {
      const form = this.$refs.archivedModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          const data = {
            ids: this.selectedRowKeys,
            ...values
          }
          customs_declaration_out_archived(data).then(res => {
            // 刷新表格
            if (res.code === 1000) {
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.archived_visible = false
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    handleClientSearch (value) {
      client_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.clientList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      })
    },
    handleClientChange (value) {
      if (value === undefined) {
        this.handleClientSearch(value)
      }
      this.queryParam.client_ids = value.join()
      console.log('handleClientChange', value)
    }
  }
}
</script>
